const PIN_SIZE = [35, 39];

const AppRoute = {
  MAIN: `/`,
  POOL: `/pool/:id`,
  AREA: `/pool/:id/:areaId`,
};

const DataMode = {
  FISH: `FISH`,
  NON_FISH: `NON_FISH`,
};

const MapColor = {
  FILL_COLOR: `#00569c`,
  FILL_COLOR_HOVER: `#007ee4`,
  STROKE_COLOR: `#283447`,
};

const Research = {
  PATHOGENS: `PATHOGENS`,
  PARASITOLOGICAL: `PARASITOLOGICAL`,
  CHEMICAL_TOXICOLOGICAL: `CHEMICAL_TOXICOLOGICAL`,
};

const ResearchTitle = {
  [Research.PATHOGENS]: {
    title: `в том числе по возбудителям болезней (бактериологических, микологических, вирусологических)`,
    titleNotMatch: `в том числе не соответствует нормам`,
  },
  [Research.PARASITOLOGICAL]: {
    title: `по паразитологическим показателям безопасности`,
    titleNotMatch: `в том числе обнаружено`,
  },
  [Research.CHEMICAL_TOXICOLOGICAL]: {
    title: `по химико-токсикологическим показателям безопасности`,
    titleNotMatch: `в том числе положительных`,
  },
};


export {
  PIN_SIZE,
  AppRoute,
  DataMode,
  MapColor,
  Research,
  ResearchTitle,
};
